import { DialogType } from '../enums/dialog-type';

export class DialogProperties {
    public type: DialogType;
    public title: string;
    public additionalInfo: string;

    constructor();
    constructor(json: any);
    constructor(json?: DialogProperties) {
        if (json) {
            this.type = json.type;
            this.title = json.title;
            this.additionalInfo = json.additionalInfo;
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/domain/models/dialog-properties.ts